import { odata } from '@bingads-webui/http-util';
import { getODataConfig } from '../model/ad-bulk';

const expireTimeDefault = 86400 * 1000; // 1 day


export function setLocalStorageWithExpire(key, data, expire) {
  const obj = {
    data,
    time: Date.now(),
    expire,
  };
  localStorage.setItem(key, JSON.stringify(obj));
}

function getLocalStorageWithExpire(key) {
  let val = localStorage.getItem(key);
  if (!val) {
    return null;
  }
  try {
    val = JSON.parse(val);
  } catch (error) {
    console.error('Error during JSON parse:', error);
    return null;
  }
  if (Date.now() - val.time > val.expire) {
    localStorage.removeItem(key);
    return { val: val.data, expired: true };
  }
  return { val: val.data, expired: false };
}

export function getKey() {
  const date = new Date();
  return `${date.getFullYear}/${date.getMonth}/${date.getDay}`;
}

export async function fetchExchangeRateMapping(serverContext) {
  const oDataConfig = getODataConfig(serverContext);
  const baseURL = `${oDataConfig.oDataPath}/Customers(${serverContext.CurrentCustomer.Id})/Accounts(${serverContext.CurrentAccount.Id})/`;
  const url = `${baseURL}/Default.GetExchangeRate`;

  try {
    const result = await odata.get(url, oDataConfig);
    if (result && result.value) {
      setLocalStorageWithExpire(getKey(), result.value, expireTimeDefault);
      return result.value;
    }
  } catch (error) {
    console.error(error + url);
  }
  return Promise.resolve();
}

export function getAccountExchangeRateFromLocalStorage(serverContext) {
  let exchangeRateMapping = getLocalStorageWithExpire(getKey());

  if (!exchangeRateMapping || exchangeRateMapping.expired) {
    exchangeRateMapping = fetchExchangeRateMapping(serverContext);
  }

  return exchangeRateMapping;
}
